var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('QR',{attrs:{"input":_vm.output},on:{"ready":_vm.__EMITready,"error":_vm.__EMITerror}})
}
var staticRenderFns = []

export { render, staticRenderFns }